module.exports = __webpack_public_path__ + "static/img/Literature.c694c96.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Literature.png
// module id = 2239
// module chunks = 61